module.exports = __webpack_public_path__ + "static/img/gengduo.e321c385.png";